import { AutoMap } from "@automapper/classes";
import { UserProjectDto } from "./user-project.dto";

export class UserProjectResponseDto {

    @AutoMap()
  public "user_project"!: UserProjectDto[];

}